import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';
import { EnforcementService } from 'src/app/Services/enforcement.service';

@Component({
    selector: 'app-editcitationreason',
    templateUrl: './editcitationreason.component.html',
    styleUrls: ['./editcitationreason.component.scss'],
    standalone: false
})
export class EditCitationReasonComponent extends ModelEditor implements OnInit {
  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    public enforcementService: EnforcementService,
    private injector: Injector,
    private toastr: ToastrService
  ) {
    super('enforcement/infringement-types', injector);
  }

  public DefaultModel() {
    return {
      Name: '',
      Description: '',
      BaseFine: 0,
      IsActive: true,
      AppealEligible: true,
      Escalations: []
    };
  }

  public AfterModelLoaded(): void {
    if (!this.FormLoaded) {
      return;
    }

    if (!this.escalations?.length) {
      this.addEscalation();
    }
  }

  public BeforeSave(): boolean {
    const escalationsControl = this.Form.get('Escalations');
    if (escalationsControl && !escalationsControl.value) {
      escalationsControl.setValue([]);
    }
    return true;
  }

  public Validators() {
    return {
      Name: { required: true },
      Description: { required: true },
      BaseFine: { required: true, min: 0 },
      Escalations: {}
    };
  }

  public get escalations(): UntypedFormArray {
    return this.Form.get('Escalations') as UntypedFormArray;
  }

  public addEscalation(): void {
    if (!this.escalations) {
      return;
    }

    const sequence = this.escalations.length + 1;
    this.escalations.push(new UntypedFormGroup({
      Id: new UntypedFormControl(null),
      Sequence: new UntypedFormControl(sequence, Validators.required),
      DaysAfterIssuance: new UntypedFormControl(0, [Validators.required, Validators.min(0)]),
      AdditionalFee: new UntypedFormControl(0, [Validators.required]),
      Description: new UntypedFormControl('')
    }));
  }

  public removeEscalation(index: number): void {
    if (!this.escalations || this.escalations.length <= 1) {
      return;
    }

    this.escalations.removeAt(index);
  }
} 
